export default "__VITE_ASSET__CaCgqek2__"